import { render, staticRenderFns } from "./AccountConfirmView.vue?vue&type=template&id=09b1fa54"
import script from "./AccountConfirmView.vue?vue&type=script&lang=js"
export * from "./AccountConfirmView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports